import { Injectable } from '@angular/core';
import {
  Router,
  UrlTree,
  CanLoad, // Import CanLoad
  Route, // Import Route
  UrlSegment,
  ActivatedRoute, // Import UrlSegment
} from '@angular/router';
import { Observable } from 'rxjs';
import { UtilsHelper } from '../utils.helper';

@Injectable({
  providedIn: 'root'
})
export class LoginAuthGuard implements CanLoad { // Implement CanLoad
  constructor(private _router: Router) {}

  // canActivate method removed

  canLoad( // Updated signature
    route: Route,
    segments: UrlSegment[]
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (UtilsHelper.IsLoggedIn) {
      this._router.navigate(['dashboard/chats']);
      return false; // Prevent loading auth module
    }
    return true; // Allow loading auth module
  }
}